/**
 * In the template, when referencing a method from the controller like a filter method:
 *
 * <code>ng-repeat="element in $ctrl.elements | filter:$ctrl.filterElements"</code>
 *
 * The method of the controller <code>filterElements</code> would be called in the context of the <code>window</code> object, not of the Angular controller.
 * Annotate the method with <code>@bind</code> to fix this.
 */
export function bind<T extends Function>(
    target: Object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<T>
): TypedPropertyDescriptor<T> | void {
    return {
        configurable: true,
        get(this: T): T {
            const bound: T = descriptor.value!.bind(this);
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: true,
                writable: true
            });
            return bound;
        }
    };
}
